export const formatPrice = (amount?: number | null) => {
  if (typeof amount !== 'number') {
    return '- €';
  }

  return (amount / 100).toFixed(2) + ' €';
};

export const parsePrice = (amount: number) => Math.round(amount * 100);
